var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneParts = function SvgPhoneParts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "phone-parts_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#phone-parts_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 16v-.5H3V12q0-.424.288-.713A.97.97 0 0 1 4 11h.75V6q.041-1.25.896-2.125Q6.5 3 7.75 3t2.125.875T10.75 6v8q0 .619.438 1.06.437.44 1.052.44.614 0 1.052-.437.437-.438.458-1.063V9H13a.93.93 0 0 1-.698-.292A1.06 1.06 0 0 1 12 8V4.5h1V4q0-.424.287-.712A.97.97 0 0 1 14 3h1q.424 0 .713.288Q16 3.575 16 4v.5h1V8q0 .424-.288.713A.97.97 0 0 1 16 9h-.75v5q-.042 1.25-.896 2.125T12.25 17a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 9.25 14V6a1.45 1.45 0 0 0-.437-1.06A1.43 1.43 0 0 0 7.76 4.5q-.614 0-1.052.438A1.52 1.52 0 0 0 6.25 6v5H7a.93.93 0 0 1 .698.292q.28.291.302.708v3.5H7v.5q0 .424-.287.712A.97.97 0 0 1 6 17z"
  }))));
};
export default SvgPhoneParts;